import React from "react";
import { WorkProjectShell } from "./WorkProjectShell";
import {
  WorkSplitRow,
  WorkMediaFrame,
  WorkTextStack,
  WorkSectionHeading,
  WorkProseBlock,
  ConcludeContainer,
} from "./styles";
import { ProjectDetails } from "../../../DesignSystem/ProjectDetails";

export default function ArgoHytosAR() {
  const ProjectBG = require("../../../../assets/videos/argo-hytos/t1.png");
  const T1 = require("../../../../assets/videos/argo-hytos/t1.png");

  return (
    <WorkProjectShell
      posterSrc={ProjectBG}
      title="ARGO-HYTOS AR"
      lead={
        <p>
          Interactive 3D and AR for four key ARGO-HYTOS products—inspect
          geometry in the app and place virtual units in your environment for
          context-rich evaluation.
        </p>
      }
    >
      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={T1}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/argo-hytos/1_ArgoHytosAR.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Product overview</WorkSectionHeading>
          <p>
            Descriptions, capabilities, and specifications for an informed view
            of each offering.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkProseBlock>
        <WorkSectionHeading>Interactive 3D and AR</WorkSectionHeading>
        <p>
          Rotate detailed models in 3D, then switch to AR to see products at
          real scale in your space.
        </p>
      </WorkProseBlock>

      <WorkProseBlock>
        <WorkSectionHeading>Labels and simulations</WorkSectionHeading>
        <p>
          Annotations clarify components and functions; interactive simulations
          illustrate real-world use.
        </p>
      </WorkProseBlock>

      <ConcludeContainer>
        <p>
          ARGO HYTOS AR combines immersive visualization with practical product
          education for customers and partners.
        </p>
      </ConcludeContainer>

      <ProjectDetails
        details={[
          { label: "Project Name", value: "Argo Hytos AR" },
          { label: "Period", value: "02.2020 - 03.2020" },
          { label: "Client", value: "ARGO-HYTOS" },
          { label: "Engine & Tools", value: "Unity, AR Foundation, C#" },
          { label: "Platform", value: "Mobile" },
          { label: "Company", value: "Radiusmedia KG" },
          { label: "Tags", value: "AR" },
        ]}
      />
    </WorkProjectShell>
  );
}
